// const store = require('../store/index');
// const helper = require('../helper');

/**
*
* Singleton Class so you could persist the data in this class even
* it's instantiated several times in different part of the program
*/
class MultipleServiceSelectedBooking {

	constructor() {
		if (!MultipleServiceSelectedBooking.instance) {
			MultipleServiceSelectedBooking.instance = this;
		}

		return MultipleServiceSelectedBooking.instance;
	}

	groupBy(field, arr = []) {
		return Object.entries(this.objectsGroupBy(arr, field));
	}

	countBookedServices(arrProducts) {
		let uniqueCount = 0;

		const groups = this.groupBy('service_group_id', arrProducts);
		for (var i = groups.length - 1; i >= 0; i--) {
			const [service_group_id, productsGroupInService] = groups[i];
			uniqueCount += this.groupBy('service_setting_id', productsGroupInService).length;
		}

		return uniqueCount;
	}

	countBookedDates(arrDates) {
		let uniqueCount = 0;

		const groups = this.groupBy('service_group_id', arrDates);
		for (var i = groups.length - 1; i >= 0; i--) {
			const [service_group_id, datesGroupInService] = groups[i];
			uniqueCount += this.groupBy('service_setting_id', datesGroupInService).length;
		}

		return uniqueCount;
	}

	countedBookedServicesEqualsDates(arrProducts, arrDates) {
		return this.countBookedServices(arrProducts) === this.countBookedDates(arrDates);
	}

	hasPaidProducts(arr) {
		return arr.some(product => product.isPaid);
	}

	uniqueServiceSettingIds(arrProducts) {
		const services = this.groupBy('service_setting_id', arrProducts);

		const arr_service_setting_id = [];
		for (service_setting_id in services) {
			arr_service_setting_id.push(service_setting_id);
		}

		return arr_service_setting_id;
	}

	selectedServices(arrProducts, arrServices) {
		const uniqueServiceSettingIdsList = this.uniqueServiceSettingIds(arrProducts);
		const usedServiceSettings = arrServices.filter(service => uniqueServiceSettingIdsList.indexOf(service.service_setting_id) > -1);
		return usedServiceSettings;
	}

	objectsGroupBy(arr, byField) {
        if (typeof arr === 'undefined') return [];
        return arr.reduce((r, a) => {
            r[a[byField]] = [...r[a[byField]] || [], a];
            return r;
        }, {})
    }
}

module.exports = MultipleServiceSelectedBooking;